import axios, { AxiosRequestHeaders } from 'axios';
import { remoteConfigGetter } from "../utils/remoteConfig";
import { loginEvent, setEmailAndMobile, setOtpData, setQrData } from "../slices/authSlice";
import { toast } from "react-toastify";
import authService from "./authService";
import { ResponceStatusService } from "../sub";

const globalHeaders: AxiosRequestHeaders = {
    'Content-Type': 'application/json',
    "X-Application-Id": String(process.env.REACT_APP_TV_APPLICATION_ID),
    "X-Stage": String(process.env.REACT_APP_ENV),
    'x-api-key': String(process.env.REACT_APP_VORTEX_KEY)
}
const apiFlowBackend = axios.create({
    baseURL: process.env.REACT_APP_VORTEX_URL,
    headers: globalHeaders
});

function authorizedHeaders(token: string) {
    return { ...globalHeaders, 'Authorization': `Bearer ${token}` }
}

async function flowLogin2fo(data: any) {
    // lets bind it some another way 
    return await apiFlowBackend.post('aux/authentication/v2/login', data);
}

async function firstFactor(data: any, token: string) {
    let headers = authorizedHeaders(token);
    // 
    return await apiFlowBackend.post('aux/authentication/v2/firstFactor', data, { headers: headers });
}

async function setMpin(data: any, accesToken: string) {
    let headers = authorizedHeaders(accesToken);
    // 
    return await apiFlowBackend.post('aux/authentication/v2/setMpin', data, { headers: headers });
}

async function secondFactor(data: any, token: string) {
    let headers = authorizedHeaders(token);
    // 
    return await apiFlowBackend.post('aux/authentication/v2/secondFactor', data, { headers: headers, withCredentials: true });
}

async function refreshAccessToken(data: any) {
    return await apiFlowBackend.post('aux/authentication/refreshLogin', data, { headers: globalHeaders, withCredentials: true });
}

async function secondFactorSso(data: any, token: string) {
    let headers = authorizedHeaders(token);
    // 
    return await apiFlowBackend.post('aux/authentication/v2/secondFactorSso', data, { headers: headers });
}

async function sendTOpt(data: any, token: string) {
    let headers = authorizedHeaders(token);
    return await apiFlowBackend.post('aux/authentication/sendTotpSms', data, { headers: headers });
}

async function getTOtpData(token: string) {
    let headers = authorizedHeaders(token);
    return await apiFlowBackend.get('aux/authentication/totp', { headers: headers });
}

async function update2faPref(data: any, token: string) {
    let headers = authorizedHeaders(token);
    return await apiFlowBackend.put('aux/authentication/update2faPref', data, { headers: headers });
}


// FORGET PASSWORD 4 API

async function forgotPasswordOtpRequest(data: any) {
    let headers = globalHeaders;
    return await apiFlowBackend.post('aux/authentication/forgot', data, { headers: headers });
}

async function forgotPasswordResendOTP(data: any) {
    let headers = globalHeaders;
    return await apiFlowBackend.post('aux/authentication/resendForgotOtp', data, { headers: headers });
}
async function resetForgotPassword(data: any) {
    let headers = globalHeaders;
    return await apiFlowBackend.post('aux/authentication/resetForgotPassword', data, { headers: headers });
}

async function verifyMfaSSO(data: any, token: string) {
    let headers = authorizedHeaders(token);
    return await apiFlowBackend.post('aux/authentication/submitMfa', data, { headers: headers });
}

async function refreshLogin(data: any, token: string) {
    let headers = authorizedHeaders(token);
    return await apiFlowBackend.post('aux/authentication/refreshLogin', data, { headers: headers });
}

async function refreshLoginOtpSend(data: any, token: string) {
    let headers = authorizedHeaders(token);
    return await apiFlowBackend.post('aux/authentication/refreshLoginOtp', data, { headers: headers });
}


async function getRedirecUrl(data: any, token: string) {
    let headers = authorizedHeaders(token);
    return await apiFlowBackend.post('aux/authentication/getRedirecUrl', data, { headers: headers });
}


async function getApplicationDetails(data: any) {
    let headers = globalHeaders;
    return await apiFlowBackend.get('aux/authentication/application/' + data.applicationId, { headers: headers });
}
async function getQrImage(data: any) {
    return await apiFlowBackend.post('aux/authentication/qrImage', data, {});
}



apiFlowBackend.interceptors.response.use(undefined, err => {
    const error = err.response;
    if (error.status === 401) {
        if (typeof window !== "undefined") {
            window.location.href = "/";
            localStorage.clear()
        }
        // Optionally, keep the ResponceStatusService if you still want to send the status event
        // ResponceStatusService.sendRes({ type: 'FLOW', status: 401 })
    }
});





function setUpSessionData(value: any, mfaType: any, dispatch: any, navigate: any, data: any) {
    let userData = value.data
    if (userData.status === 'success') {
        let newData = { ...data, refreshToken: userData.refreshToken, mfaType: userData.mfa_type, mfaEnabled: userData.mfaEnabled }
        let dataSet = { data: newData, user_id: data.clientCode }
        dispatch(setOtpData(dataSet))
        toast.success(`OTP Verified`)
        const refreshData = { refreshToken: userData.refreshToken, ssoToken: userData.ssoToken, mfaType: userData.mfaType, deviceId: data.deviceId, tradingActive: userData.tradingActive }
        const userModify = { ...userData.data, ...refreshData }

        // login event
        dispatch(setEmailAndMobile({ mobile: null, email: userModify.email }))
        dispatch(loginEvent({ mobile: null, email: userModify.email }))

        authService.saveUserSessionFlow(userModify, refreshData, dispatch)
        if (mfaType === 'otp') navigate("/setTOtp", { replace: true })
        if (mfaType === 'totp') navigate("/apps", { replace: true });
    }
}

function setUpQrSessionData(value: any, dispatch: any, navigate: any, data: any) {
    let userData = value
    if (userData.status === 'success') {
        let newData = { ...data, refreshToken: userData.refreshToken, mfaType: data.stateData.mfaType, mfaEnabled: userData.mfaEnabled }
        let dataSet = { data: newData, user_id: userData.data.clientCode }
        dispatch(setQrData(dataSet))
        const refreshData = { refreshToken: userData.refreshToken, ssoToken: userData.ssoToken, mfaType: data.stateData.mfaType, deviceId: data.stateData.deviceId, tradingActive: userData.tradingActive }
        const userModify = { ...userData.data, ...refreshData }

        // login event
        dispatch(setEmailAndMobile({ mobile: null, email: userModify.email }))
        dispatch(loginEvent({ mobile: null, email: userModify.email }))

        authService.saveUserSessionFlow(userModify, refreshData, dispatch)
        toast.success(`Logged In Successfully`)
        navigate("/apps", { replace: true });
    }
}
const flowBackEndServices2 = {
    refreshAccessToken, firstFactor, flowLogin2fo, sendTOpt, getTOtpData, setUpSessionData, update2faPref,
    forgotPasswordOtpRequest, forgotPasswordResendOTP, resetForgotPassword, verifyMfaSSO,
    refreshLogin, refreshLoginOtpSend, getRedirecUrl, getApplicationDetails, getQrImage, setUpQrSessionData, setMpin, secondFactor, secondFactorSso
};

export default flowBackEndServices2;
